import image1 from '../assets/images/Image_fx.jpg'
import image2 from '../assets/images/Image_fx2.jpg'
import image3 from '../assets/images/Image_fx3.jpg'
import image4 from '../assets/images/Image_fx4.jpg'
import image5 from '../assets/images/Image_fx5.jpg'
import image6 from '../assets/images/Image_fx6.jpg'
import image7 from '../assets/images/Image_fx7.jpg'
import image8 from '../assets/images/Image_fx8.jpg'
import image9 from '../assets/images/Image_fx9.jpg'

const trainers = [
    {
    name: 'Emre Comertoglu',
    startYear: 2006,
    specializations: [
      'Mobility & Flexibility Training',
      'Functional Strength Training',
      'Youth Athletic Development',
      'Adult & Senior Fitness',
      'Injury Prevention'
    ],
    certifications: [
      'NASM-CPT',
      'Precision Nutrition'
    ],
    bio: 'Emre is a fitness and nutrition expert with over 20 years of experience specializing in mobility, flexibility, and strength training for adults and young athletes. His mission is to help people move better, feel stronger, and live more functional lives at every stage of life. With firsthand experience navigating the physical changes that come with age, Emre emphasizes staying mobile, strong, and injury-free through practical, real-world training. He has worked with hundreds of clients ranging in age from 15 to 93, helping adults reduce pain and improve mobility, supporting seniors in maintaining independence, and training young athletes to build strength while minimizing injury risk. Emre’s approach is rooted in personalized, functional fitness programs designed to support the way you actually live—improving balance, joint health, strength, and overall quality of life.',
    image: image1,
    website: 'https://sarahjohnsonfit.com',
    instagram: 'https://instagram.com/sarahjohnsonfit',
  },
  {
    name: 'Sal Benitez',
    startYear: 2011,
    certifications: [
      'NASM CPT',
      'NASM Corrective Exercise',
      'NASM Fitness Nutrition ',
      'NASM Senior Fitness',
      'NASM Women Fitness',
    ],
    specializations: [
      'Corrective Exercise',
      'Nutritional Guidance',
      'Fat Loss & Body Composition',
      'Injury Prevention',
      'Strength & Conditioning',
      'Longevity Training'
    ],
    degrees: [
      "Bachelor's of Science in Kinesiology",
    ],
    bio: '​I am a movement specialist with a degree in Kinesiology and over 15 years of experience in the fitness industry. My work is dedicated to the science of how the body moves, recovers, and builds strength across the entire human lifespan. ​My approach is built on the reality that fitness is not one-size-fits-all. Every individual is unique, possessing a specific skeletal structure and movement history that requires evidence-based programming rather than trendy social media exercises or generic templates. I integrate my nutrition expertise to ensure your fueling strategy is as precise as your training, moving away from generalized advice to address your specific metabolic and physiological needs.',
    image: image2,
    website: 'https://mikerodriguezfit.com',
    instagram: 'https://instagram.com/mikerodriguezfit',
  },
 
  {
    name: 'Shane Napier',
    startYear: 2006,
    specializations: [
    'Personal Training',
    'Strength Training',
    'Mobility & Flexibility',
    'Injury Prevention',
    'Functional Movement',
    'Metabolic Conditioning',
    'Kettlebells',
    'Kickboxing Conditioning',
    'Balance Training (All Ages)',
    'Nutrition Coaching',
    'Recovery Techniques'
  ],
    certifications: ['CEC'],
    bio: 'Shane is a highly experienced personal trainer with over 20 years in the fitness industry and more than 100 hours of continuing education. His extensive background in functional movement, injury prevention, and performance training allows him to create safe, effective, and customized programs for every client. At SNAP Wellness, Shane helps individuals improve mobility, build strength, and increase energy—whether they’re recovering from injury, starting their fitness journey, or training at an advanced level. His approach makes long-term wellness accessible, sustainable, and enjoyable. If you want a more technical, more athlete-focused, or more client-friendly version for different pages (trainer cards vs. full profile), I can tailor it exactly to that use case.',
    image: image3,
    instagram: 'https://instagram.com/emilychenfit',
  },

 {
    name: 'Craig Gentile',
    startYear: 2019,
    specializations: [
      'Personal Training (All Levels)',
      'Strength & Muscle Development',
      'Functional Training',
      'Military-Inspired Training',
    ],
    bio: "Craig is a Marine Corps Veteran and CSULB graduate with over six years of experience helping clients build strength, confidence, and sustainable fitness habits. His disciplined yet supportive approach makes fitness approachable for beginners and effective for experienced athletes alike. After discovering his own passion for training later in life, Craig is driven to help others find their spark and achieve goals they once thought were out of reach—both in and out of the gym. If you want a slightly more friendly or more hype/coach-energy version for a website card or trainer profile carousel, I can tweak it in seconds.",
    image: image4,
    website: 'https://marcusthompsonfit.com',
    instagram: 'https://instagram.com/marcusthompsonfit',
  },
 /*    {
    name: 'Jessica Martinez',
    title: 'Pre/Postnatal Fitness Specialist',
    experience: '4 Years Experience',
    specializations: ['Prenatal Fitness', 'Postpartum Recovery', 'Core Rehabilitation'],
    certifications: ['NASM-CPT', 'Pre/Postnatal Certified'],
    bio: 'Jessica provides safe and effective fitness programs for expecting and new mothers. Her compassionate approach helps women maintain strength and wellness throughout their pregnancy journey and beyond.',
    image: image5,
    website: 'https://jessicamartinezfit.com',
    instagram: 'https://instagram.com/jessicamartinezfit',
  },
  {
    name: 'David Kim',
    title: 'Bodybuilding & Hypertrophy Coach',
    experience: '9 Years Experience',
    specializations: ['Bodybuilding', 'Muscle Growth', 'Competition Prep'],
    certifications: ['ISSA-CPT', 'ISSA Bodybuilding Specialist'],
    bio: 'David has competed professionally and now helps clients build muscle and sculpt their physiques. His detailed programming and nutrition guidance have helped numerous clients achieve their body composition goals.',
    image: image6,
    website: 'https://davidkimfit.com',
    instagram: 'https://instagram.com/davidkimfit',
  },
  {
    name: 'Rachel Williams',
    title: 'Senior Wellness Coach',
    experience: '6 Years Experience',
    specializations: ['Weight Management', 'Lifestyle Coaching', 'Group Fitness'],
    certifications: ['ACE-CPT', 'Health Coach Certification'],
    bio: 'Rachel takes a holistic approach to fitness, focusing on sustainable lifestyle changes. Her supportive coaching style and group fitness expertise create a motivating environment for lasting transformation.',
    image: image7,
    website: 'https://rachelwilliamsfit.com',
    instagram: 'https://instagram.com/rachelwilliamsfit',
  },
  {
    name: 'Alex Turner',
    title: 'Sports Performance Coach',
    experience: '5 Years Experience',
    specializations: ['Speed Training', 'Agility', 'Sport-Specific Training'],
    certifications: ['CSCS', 'USAW Sports Performance'],
    bio: 'Alex works with athletes looking to elevate their game. His expertise in speed, agility, and power development helps athletes gain the competitive edge they need to excel in their sport.',
    image: image8,
    website: 'https://alexturnerfit.com',
    instagram: 'https://instagram.com/alexturnerfit',
  },
  {
    name: 'Olivia Patel',
    title: 'Senior Strength & Conditioning Coach',
    experience: '7 Years Experience',
    specializations: ['Powerlifting', 'Olympic Lifting', 'Strength Development'],
    certifications: ['NSCA-CSCS', 'USAW Level 1'],
    bio: 'Olivia is passionate about teaching proper lifting techniques and building raw strength. Her technical expertise and patient teaching style help clients master complex movements and reach new personal records.',
    image: image9,
    website: 'https://oliviapatelfit.com',
    instagram: 'https://instagram.com/oliviapatelfit',
  } */
];

export default trainers;
